module.exports = __webpack_public_path__ + "img/usuarios.296b5643.svg";